var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.636 0A4.364 4.364 0 0 1 48 4.364v39.272A4.364 4.364 0 0 1 43.636 48H4.364A4.364 4.364 0 0 1 0 43.636V4.364A4.364 4.364 0 0 1 4.364 0h39.272ZM32.89 10.667h-16c-1.414 0-2.57 1.1-2.661 2.49l-.006.176v21.334a2.666 2.666 0 0 0 5.328.175l.005-.175v-8H31.11a2.666 2.666 0 0 0 .175-5.328l-.175-.005-11.556-.002v-5.333L32.889 16a2.667 2.667 0 0 0 0-5.333Z",
    fill: "url(#logo_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__a",
    x1: 66.867,
    y1: -11.452,
    x2: -10.845,
    y2: 54.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A101FF"
  })))));
};
export default SvgLogo;